module.exports = __webpack_public_path__ + "img/logo.6dec9e7d.png";